var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
                callback: _vm.visibilityChanged,
                throttle: _vm.throttle,
                intersection: {
                    rootMargin: _vm.rootMargin,
                    threshold: _vm.threshold
                }
           }),expression:"{\n                callback: visibilityChanged,\n                throttle: throttle,\n                intersection: {\n                    rootMargin: rootMargin,\n                    threshold: threshold\n                }\n           }"}],tag:"component",staticClass:"wpimage",class:[_vm.imageClass, _vm.classes],attrs:{"alt":_vm.alt,"width":_vm.imageWidth}},'component',_vm.imageSrc,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }